import React from 'react';
import { Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setProfileMeta } from '../../redux/slice/tanProfileSlice';
import { useTranslation } from 'react-i18next';
import { slice_map } from '../../components/componentMap/componentMap';
import SwipeableProfileList from '../../components/profileList/SwipeableProfileList';
import "../profiles/tanProfiles.css";

const ScanProfileSelection = () => {
  const { t } = useTranslation("translation", { keyPrefix: "scanProfileSelection" });
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const mappedComponents = useSelector((state) => state?.tanProfile?.mappedComponents);

  return (
    <div className='profiles-container'>
      <div className='profiles-content'>
        <div className='profiles-top'>
          {/* <div className='profiles-header'>
            <h1>{t("header", "Tan Profiles").toUpperCase()}</h1>
          </div> */}
          <div className='profile-instructions'>
            <p>{t("instructions.toptext", "Tap a profile to select, or create a new session")}</p>
          </div>
        </div>

        {/* Swipable List Component */}
        <SwipeableProfileList
        bypassEdit={true}/>

        
      </div>
    </div>
  );
};

export default ScanProfileSelection;
